import styled from 'styled-components'
import { Row } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'

export const Container = styled.div`
  max-width: 100%;
  padding: 20px 0;
`

export const FormRow = styled(Row)`
  margin-top: 10px;
  margin-bottom: 10px;
  max-width: 400px;
`

export const Select = styled.select`
  width: 100%;
  border: 0;
  border-radius: 15px;
  padding: 14px 14px;
  max-width: 400px;
  font-size: 1rem;
  margin-right: 30px;
`

export const LinkText = styled.div`
  color: ${variables.colors.jade.medium};
  margin-bottom: 8px;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`

export const Collapse = styled.div`
  max-height: ${props => (props.active ? '400px' : '0')};
  width: 100%;
  overflow: hidden;
  transition: all 0.5s ease;
`
